import type {
  TopicPublicationApplySearchCriteria,
  TopicPublicationClearSearchCriteria,
} from "domains/publication/actionTypes";
import { TopicPublicationActionTypes } from "domains/publication/actionTypes";

export const applyPublicationSearchCriteria = (
  payload?: TopicPublicationApplySearchCriteria["payload"],
  meta?: TopicPublicationApplySearchCriteria["meta"],
): TopicPublicationApplySearchCriteria => ({
  type: TopicPublicationActionTypes.APPLY_SEARCH_CRITERIA,
  payload,
  meta,
});

export const clearPublicationSearchCriteria = (): TopicPublicationClearSearchCriteria => ({
  type: TopicPublicationActionTypes.CLEAR_SEARCH_CRITERIA,
});
